export default __webpack_public_path__ + "static/media/eval.a866e877.svg";